<template>
	
<div class="lifestyle" :class="{'is-active': active}">

	<div class="lifestyle-title">{{ section.lifestyle.title }}</div>

	<div class="lifestyle-icons">

		<div class="lifestyle-icons-item" :class="{'is-active': $_.contains(highlighted, icon)}" v-for="(text, icon) in section.lifestyle.icon" :key="icon" v-on:click="onHighlightClick(icon)">
			
			<div class="lifestyle-icons-item-icon" :class="{['is-' + icon]: true}"></div>
			<div class="lifestyle-icons-item-text">{{ text }}</div>
			
		</div>

	</div>

	<com-next v-if="!completed && !$isPatient" v-on:click.native="$emit('next')" class="lifestyle-next" />

</div>

</template>

<script>

import comNext from './../common/Next'

export default {

	props: ['section', 'active', 'completed'],

	components: {
		'com-next': comNext
	},

	data: function() {

		return {
			highlighted: []
		}

	},

	methods: {

		onHighlightClick: function(key) {

			if (this.$isPatient) {

				this.$emit('info', key)
				return

			}

			if (this.$_.contains(this.highlighted, key)) {

				this.highlighted.splice(this.highlighted.indexOf(key), 1)

			} else {

				this.highlighted.push(key)

			}

		}

	}
	
}

</script>

<style scoped>

.lifestyle {
	width: 50%;
	height: 297px;
	background-color: #656D78;
	border-top-right-radius: 48px;
	padding: 30px;
	filter: grayscale(100%);
	opacity: 0.25;
	transition: all 300ms linear;
	cursor: pointer;
}

.lifestyle.is-active {
	opacity: 1;
	filter: grayscale(0%);
}

.lifestyle-title {
	color: #fff;
	font-size: 18px;
	letter-spacing: 1px;
	text-align: right;
	font-weight: 600;
	text-transform: uppercase;
	margin-bottom: 40px;
}

.lifestyle-title:after {
	content: ' ';
	display: block;
	position: absolute;
	height: 2px;
	right: 0px;
	width: 75px;
	bottom: -10px;
	background-color: #fff;
}

.lifestyle-icons {
	display: flex;
	flex-wrap: wrap;
	padding-left: 88px;
}

.lifestyle-icons-item {
	width: calc(50% - 4px);
	padding-right: 4px;
	border: 2px solid #8C929A;
	border-radius: 30px;
	height: 44px;
	display: flex;
	align-items: center;
	padding: 4px 4px 4px 46px;
	margin: 0px 8px 8px 0px;
	color: #fff;
	line-height: 18px;
	font-size: 13px;
	font-weight: 600;
}

.lifestyle-icons-item.is-active,
.lifestyle-icons-item:hover {
	background-color: #ddd;
	color: #333;
}

.lifestyle-icons-item:nth-child(even) {
	margin-right: 0px;
}

.lifestyle-icons-item-icon {
	position: absolute;
	left: -2px;
	top: -2px;
	width: 44px;
	height: 44px;
	border-radius: 30px;
	border: 2px solid #8C929A;
	background-color: #ddd;
	background-position: 50% 50%;
	background-repeat: no-repeat;
}

.lifestyle-icons-item-icon.is-smoking {
	background-image: url(~@/assets/aid/risk/lifestyle/smoking.svg);
}

.lifestyle-icons-item-icon.is-weight {
	background-image: url(~@/assets/aid/risk/lifestyle/weight.svg);
}

.lifestyle-icons-item-icon.is-diet {
	background-image: url(~@/assets/aid/risk/lifestyle/diet.svg);
}

.lifestyle-icons-item-icon.is-activity {
	background-image: url(~@/assets/aid/risk/lifestyle/activity.svg);
}

.lifestyle-icons-item-icon.is-alcohol {
	background-image: url(~@/assets/aid/risk/lifestyle/alcohol.svg);
}

.lifestyle-next {
	position: absolute;
	bottom: 15px;
	right: 30px;
}

.is-patient .lifestyle {
	border-radius: 0 48px 48px 0;
}

.is-mobile .lifestyle {
	width: 100% !important;
	border-radius: 32px !important;
	margin-bottom: 8px;
}

</style>